export const getShareS3Path = `query MyQuery($bucket: String!, $key: String!) {
  getShareS3Path(bucket: $bucket, key: $key) {
    SignedUrl
  }
}`;
